import { useCallback, useEffect, useRef } from 'react';
import { hotjar } from 'react-hotjar';
import { isSyntheticMonitor, loadHotjar } from '../utils';

const EXIT_INTENT_SURVEY_EVENT = 'tax_contact_step_exit_intent';
const EXIT_INTENT_SURVEY_SHOWN_KEY = 'taxExitIntentHotjarSurveyShown';
const EXIT_INTENT_SURVEY_DELAY_MS = 30_000;

// react-use-wizard unmounts a step when the user leaves it, so the cleanup
// cancels the survey for anyone who moves on before the delay elapses. Steps
// that await a request before advancing should also call the returned cancel
// function on submit, so the survey can't fire mid-request.
function useHotjarExitIntentSurvey(): () => void {
  const timer = useRef<ReturnType<typeof setTimeout>>(undefined);

  const cancel = useCallback(() => clearTimeout(timer.current), []);

  useEffect(() => {
    if (
      isSyntheticMonitor() ||
      sessionStorage.getItem(EXIT_INTENT_SURVEY_SHOWN_KEY)
    ) {
      return;
    }

    loadHotjar();
    timer.current = setTimeout(() => {
      sessionStorage.setItem(EXIT_INTENT_SURVEY_SHOWN_KEY, 'true');
      hotjar.event(EXIT_INTENT_SURVEY_EVENT);
    }, EXIT_INTENT_SURVEY_DELAY_MS);

    return cancel;
  }, [cancel]);

  return cancel;
}

export {
  useHotjarExitIntentSurvey,
  EXIT_INTENT_SURVEY_EVENT,
  EXIT_INTENT_SURVEY_SHOWN_KEY,
  EXIT_INTENT_SURVEY_DELAY_MS
};
